"use client";

import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactPrompt() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="bg-light-background py-24">
      <div className="container mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {}
          <div ref={leftRef} className="transition-all duration-150 ease-out" style={{
          opacity: leftVisible ? 1 : 0,
          transform: leftVisible ? "translateY(0)" : "translateY(20px)"
        }}>
            <h2 className="font-display text-4xl md:text-5xl text-foreground-light mb-6 leading-tight">
              Ready to Preserve Your Wedding Memories?
            </h2>
            <p className="font-sans text-lg text-foreground-light/80 leading-relaxed">
              Let's create something beautiful together. Contact AB Studios today to discuss your photography and videography needs for your special day.
            </p>
          </div>

          {}
          <Separator orientation="vertical" className="hidden lg:block absolute left-1/2 top-0 bottom-0 h-full bg-foreground-light/20" style={{
          width: "1px"
        }} />

          {}
          <div ref={rightRef} className="flex justify-start lg:justify-center transition-all duration-150 ease-out" style={{
          opacity: rightVisible ? 1 : 0,
          transform: rightVisible ? "translateY(0)" : "translateY(20px)",
          transitionDelay: "100ms"
        }}>
            <Link to="#" className="inline-block">
              <Button size="lg" className="bg-primary text-foreground-primary hover:bg-primary-hover hover:scale-[1.03] transition-all duration-[120ms] ease-[var(--ease-spring)] px-8 py-6 text-base font-semibold rounded-md shadow-soft">
                Get In Touch Today
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}